import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL, BUSINESS, CONTACT_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function AboutCTA() {
  const photo = PHOTOS.sign;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-28 sm:py-32 lg:py-40"
      aria-labelledby="about-cta-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,oklch(0.259_0.042_163.6/0.84)_0%,oklch(0.259_0.042_163.6/0.93)_100%)]"
        aria-hidden="true"
      />

      <Reveal className="mx-auto max-w-3xl px-4 text-center text-cream sm:px-6">
        <p className="eyebrow text-sand">Come Stay Awhile</p>
        <h2
          id="about-cta-title"
          className="mt-4 text-balance font-display text-3xl leading-tight sm:text-4xl lg:text-[3rem]"
        >
          Experience the Welcoming Side of South Texas
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg">
          Whether you are traveling with your RV, planning a fishing trip, visiting for work,
          gathering with family, or looking for a comfortable seasonal stay, Amigo Inn is ready to
          welcome you.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Button asChild variant="book" size="ctaLg">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Check Availability <ArrowRight aria-hidden="true" />
            </a>
          </Button>
          <Button asChild variant="outlineLight" size="ctaLg">
            <Link to={routeTo(CONTACT_PATH)}>Contact the Park</Link>
          </Button>
        </div>
        <a
          href={BUSINESS.phoneHref}
          className="link-underline mt-8 inline-flex text-sm font-semibold text-sand"
        >
          <Phone className="size-4" aria-hidden="true" /> Call {BUSINESS.phone}
        </a>
      </Reveal>
    </section>
  );
}
